import { Component, input } from '@angular/core';

@Component({
  selector: 'ui-empty-state',
  standalone: true,
  template: `
    <div class="empty-state">
      <i [class]="icon()"></i>
      <p>{{ message() }}</p>
    </div>
  `,
  styles: [`
    .empty-state { 
      text-align: center; 
      padding: 2rem; 
      color: var(--text-secondary); 
    }
    .empty-state i { 
      font-size: 2rem; 
      display: block; 
      margin-bottom: 0.5rem; 
      opacity: 0.5; 
    }
    .empty-state p {
      margin: 0;
    }
  `]
})
export class EmptyStateComponent {
  icon = input.required<string>();
  message = input.required<string>();
}
